export enum ProfilePrivacy {
    Public = 'PUBLIC',
    Unlisted = 'UNLISTED',
    ReadOnly = 'READONLY',
    Private = 'PRIVATE'
}

export const getProfilePrivacyFriendlyName = (privacy: ProfilePrivacy) => {
    switch (privacy) {
        case ProfilePrivacy.Public:
            return 'Public';
        case ProfilePrivacy.Unlisted:
            return 'Unlisted';
        case ProfilePrivacy.ReadOnly:
            return 'Read-only';
        case ProfilePrivacy.Private:
            return 'Private';
    }
}
